export default __webpack_public_path__ + "static/media/memo.027239cd.svg";